export const TIERS = [
  {
    id: "drona",
    name: "Drona",
    category: "Guru Advisory",
    tagline: "The teacher who prepares you for battle",
    priceLabel: "₹999 Flat Fee",
    basePrice: 999,
    icon: "Shield",
    color: "#4FC3F7",
    forWhen: "\u201cI don\u2019t want to make a \u20b915\u201330 lakh decision based on YouTube videos alone.\u201d",
    features: [
      "Which car & variant to buy",
      "Dealer selection guidance",
      "Colour & accessory guide",
      "Finance vs cash advisory",
      "Written report delivered",
    ],
    cta: "Get My Advice",
    nextSteps: [
      "Tell us your budget, use-case and shortlist (if any)",
      "We research variants, dealers and finance options",
      "You receive a written recommendation report",
      "You decide — with clarity, not guesswork",
    ],
  },
  {
    id: "arjuna",
    name: "Arjuna",
    category: "Remote Negotiation",
    tagline: "The archer who never misses the target",
    priceLabel: "₹1,499 + 20% of savings",
    basePrice: 1499,
    icon: "Crosshair",
    color: "#8B5CF6",
    forWhen: "\u201cI know what I want. I just don\u2019t want to negotiate with the dealer myself.\u201d",
    features: [
      "Everything in Drona",
      "We call & negotiate with dealer",
      "Best price extraction",
      "Accessories negotiation",
      "Insurance advisory",
    ],
    cta: "Negotiate My Deal",
    nextSteps: [
      "Upload your dealer quote (car, variant, city, dealer)",
      "CaarSaarthi reviews it against benchmarks",
      "A negotiation strategy is prepared",
      "The dealership is contacted and negotiated with",
      "You receive the final negotiated price",
      "You decide whether to accept",
    ],
  },
  {
    id: "bhishma",
    name: "Bhishma",
    category: "Negotiation + Remote PDI",
    tagline: "The invincible protector of your interests",
    priceLabel: "₹2,499 + 20% of savings",
    basePrice: 2499,
    icon: "Crown",
    color: "#F43F5E",
    highlight: true,
    badge: "Most Popular",
    forWhen: "\u201cI want someone with me until the car is actually delivered.\u201d",
    features: [
      "Everything in Arjuna",
      "Dedicated personal advisor",
      "Just a call away — guided remotely",
      "60+ point PDI portal, advisor-assisted",
      "Document verification",
      "On-call defect reporting",
    ],
    cta: "Negotiate + Protect",
    nextSteps: [
      "Upload your dealer quote and get matched to a dedicated advisor",
      "We negotiate the price, insurance, accessories and charges",
      "You get access to the 60+ point remote PDI portal before delivery",
      "Documents are verified and any defects escalated on your behalf",
      "You accept delivery with confidence",
    ],
  },
  {
    id: "madhav",
    name: "Madhav",
    category: "Premium End-to-End",
    tagline: "The divine guide from start to finish",
    priceLabel: "Custom Pricing",
    basePrice: 0,
    icon: "Star",
    color: "#94A3B8",
    comingSoon: true,
    forWhen: "\u201cI want end-to-end support, including a personal presence at delivery.\u201d",
    features: [
      "Everything in Bhishma",
      "Physical presence at delivery",
      "In-person PDI inspection",
      "Test drive arrangement",
      "Loan processing support",
      "Post-purchase support 30 days",
    ],
    cta: "Launching Soon — Stay Tuned",
  },
];

export const NEVERS = [
  "Take a rupee of dealer commission",
  "Push a specific brand for kickbacks",
  "Bundle inflated insurance policies",
  "Hide the true on-road price",
  "Recommend accessories at MRP",
];

export const ALWAYS = [
  "Fight for the lowest possible on-road price",
  "Show you the full comparison sheet",
  "Audit every hidden charge line-by-line",
  "Represent you — never the dealership",
  "Refund our fee if we don't beat the benchmark",
];

export const HOW_STEPS = [
  {
    n: "01",
    title: "You get a dealer quote",
    body: "Visit your nearest dealer showroom and get the on-road price quotation for the car and variant you want. That's all you do. Your job ends here.",
  },
  {
    n: "02",
    title: "We negotiate with the same dealership",
    body: "We contact the exact same dealership for the best possible on-road price — armed with market benchmarks, deal intelligence and a structured negotiation strategy. Same dealer. Different conversation.",
  },
  {
    n: "03",
    title: "We compare nearby dealerships",
    body: "If there are other dealerships nearby, we get them competing too — so the price you receive is checked against the best on-road price available, not just one quote. No dealer negotiates against themselves.",
  },
  {
    n: "04",
    title: "You drive away smiling",
    body: "We share negotiated price quotations equal to or exceeding the discounts promised by us. You go back, confirm, and drive your new car home — thousands of rupees richer. Your savings. Your car. Our pride.",
  },
];

export const PROBLEMS = [
  {
    n: "01",
    title: "The dealer works for the dealer.",
    body: "Sales incentives, hidden targets, corporate schemes — every rupee off your quote is a rupee added to their bonus. You are the opposition, not the customer.",
  },
  {
    n: "02",
    title: "Comparison sites are paid by the dealer.",
    body: "Every 'best price' aggregator is running a lead-gen model. The dealer pays them per submission. Your data is the product. Your discount is the crumbs.",
  },
  {
    n: "03",
    title: "Insurance is a silent margin.",
    body: "That ₹80,000 policy carries roughly 22% commission baked in — money you're paying, that isn't buying you any more coverage.",
  },
  {
    n: "04",
    title: "PDI is theatre.",
    body: "The pre-delivery inspection you're 'walked through' is a marketing tour. Half the checks are visual. The critical scans — battery load, paint depth, OBD codes — are almost never done.",
  },
];

export const PDI_TOOLS = [
  { name: "Paint Depth Gauge", body: "Detects re-sprayed panels invisible to the eye." },
  { name: "OBD-II Scanner", body: "Reads stored & pending fault codes from ECU." },
  { name: "Battery Load Tester", body: "Validates cranking amps + true health %." },
  { name: "Endoscope Camera", body: "Underbody, cavity and engine-bay inspection." },
  { name: "Digital Multimeter", body: "Alternator output & parasitic drain check." },
  { name: "Tyre DOT Reader", body: "Tyre age, wear pattern and rotation history." },
];

export const CASE_STUDIES = [
  {
    car: "Hyundai Verna SX(O)",
    city: "Bengaluru",
    dealer: 1870000,
    final: 1655000,
    saved: 215000,
    quote: "I walked in ready to sign. My Saarthi got me ₹2.15L off in 48 hours.",
    buyer: "Rohan M., Founder",
    breakdown: [
      { label: "Dealer discount", value: "₹1,65,000" },
      { label: "Insurance re-negotiated", value: "₹32,000" },
      { label: "Accessories package", value: "₹18,000" },
    ],
  },
  {
    car: "Toyota Fortuner Legender 4x4",
    city: "Mumbai",
    dealer: 5240000,
    final: 5062000,
    saved: 178000,
    quote: "The insurance quote alone had ₹42k of fat in it. I would never have caught it.",
    buyer: "Neha S., Doctor",
    breakdown: [
      { label: "Dealer discount", value: "₹1,10,000" },
      { label: "Insurance re-negotiated", value: "₹42,000" },
      { label: "Other charges removed", value: "₹26,000" },
    ],
  },
  {
    car: "Kia Seltos GT Line",
    city: "Delhi NCR",
    dealer: 1980000,
    final: 1838000,
    saved: 142000,
    quote: "Three dealerships bidding against each other. I just picked the lowest.",
    buyer: "Aditya R., Consultant",
    breakdown: [
      { label: "Dealer competition", value: "₹96,000" },
      { label: "Accessories package", value: "₹28,000" },
      { label: "Dealer charges removed", value: "₹18,000" },
    ],
  },
];

export const WHEN_TO_USE = [
  { timing: "Before choosing a car", tier: "drona", question: "\u201cWhich car/variant is right?\u201d" },
  { timing: "After getting your quote", tier: "arjuna", question: "\u201cI've chosen. Negotiate it.\u201d" },
  { timing: "Before booking / delivery", tier: "bhishma", question: "\u201cNegotiate + PDI + protection.\u201d" },
];

export const DIY_COMPARISON = [
  { you: "Occasional buyer", dealer: "Daily seller" },
  { you: "Limited market visibility", dealer: "Constant market visibility" },
  { you: "Emotional purchase", dealer: "Commercial transaction" },
  { you: "One quote", dealer: "Multiple deals" },
  { you: "Limited time", dealer: "Negotiation is their job" },
];

export const TESTIMONIALS = [
  {
    quote: "I've bought 4 cars in my life. This was the first time I felt like someone was on my side.",
    name: "Kartik B.",
    car: "Maruti Grand Vitara Alpha+",
    rating: 5,
  },
  {
    quote: "Saved ₹1.4 lakh and 3 weekends of showroom torture. Worth every rupee.",
    name: "Sana V.",
    car: "Hyundai Creta SX(O)",
    rating: 5,
  },
  {
    quote: "My Saarthi caught a re-sprayed bumper on a 'brand-new' car. I'd have driven off with damaged goods.",
    name: "Mihir T.",
    car: "Toyota Innova Crysta",
    rating: 5,
  },
  {
    quote: "Straight-up honest. No upsell. Just numbers, benchmarks and a clean deal.",
    name: "Priya G.",
    car: "Mahindra XUV700 AX7L",
    rating: 5,
  },
  {
    quote: "The dealer stopped negotiating with me the moment my Saarthi joined the call.",
    name: "Ravi K.",
    car: "Volkswagen Virtus GT",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "How is CaarSaarthi different from a broker or comparison site?",
    a: "Brokers and comparison sites are paid by the dealer per lead. That's why the 'best deal' always ends at their partner showroom. We are paid only by you. Zero rupees ever flow to us from any dealer, ever. That's the ghost clause: if a dealer offers us a commission, we refund your fee instead.",
  },
  {
    q: "How much can I actually save?",
    a: "Our current average is ₹40,000 per deal, and it scales with the car's price — the more expensive the car, the more there typically is to negotiate off. Every deal comes with a signed savings benchmark, and our performance fee is charged only on verified savings.",
  },
  {
    q: "What cities do you cover?",
    a: "We currently operate PAN-India for advisory & remote negotiation and remote PDI. Wherever you are, our team can negotiate with your local dealership and guide you through a remote pre-delivery inspection.",
  },
  {
    q: "How long does the process take?",
    a: "From first call to signed benchmark: 24–72 hours. From benchmark to delivery: usually 7–14 days depending on model availability. Luxury and imports can go up to 30 days.",
  },
  {
    q: "What's the ghost clause?",
    a: "If any dealer offers us any commission, cashback, or referral bonus during your deal, we forfeit it AND refund your entire CaarSaarthi fee. Written into every engagement contract. Non-negotiable.",
  },
  {
    q: "Do you cover used cars?",
    a: "Not yet. Our expertise is calibrated for new car negotiation, PDI on freshly-manufactured units, and dealer-margin structures. Used car coverage is on our 2026 roadmap.",
  },
  {
    q: "Can I use Arjuna if I've already chosen exactly which car I want?",
    a: "Yes — that's exactly who Arjuna is built for. If you already know the car and variant, hand us your dealer quote and we take it from there.",
  },
  {
    q: "What does Drona do that Arjuna doesn't?",
    a: "Drona helps you decide what to buy — car, variant, dealer, finance vs cash. Arjuna assumes you've already decided, and focuses entirely on negotiating the price with the dealer you've chosen.",
  },
  {
    q: "What is included in Bhishma?",
    a: "Everything in Arjuna, plus a dedicated personal advisor, a 60+ point remote PDI portal, document verification and on-call defect reporting through delivery.",
  },
  {
    q: "Will the dealer know I'm using CaarSaarthi?",
    a: "Yes — we contact the dealership directly and negotiate on your behalf, so the dealer knows they're speaking with your representative, not you.",
  },
  {
    q: "What if I decide not to buy after you've negotiated the deal?",
    a: "The choice to buy is always yours. But once we deliver the promised savings, the performance fee applies whether you go ahead with the purchase or not.",
  },
];

export const TRUST_BADGES = [
  { k: "₹40K", v: "average savings per deal" },
  { k: "0%", v: "dealer commission — ever" },
  { k: "100%", v: "buyer-side representation" },
];

export const NEED_YES = [
  "You don't know whether the quoted deal is actually good",
  "You don't want to negotiate with multiple dealers yourself",
  "You're unsure which variant, accessories or insurance combination makes sense",
  "You want someone whose incentive is aligned with your savings, not the dealership's sale",
];

export const NEED_NO = [
  "You genuinely enjoy negotiating with dealers yourself",
  "You already have multiple competitive quotes in hand",
  "You're comfortable handling the entire buying process independently",
];

export const DECISION_TREE = [
  {
    q: "I haven't chosen my car yet",
    a: "Drona",
    body: "Get clarity on which car, variant and dealer is right for you before you spend a rupee.",
    tier: "drona",
  },
  {
    q: "I've chosen my car and need a better price",
    a: "Arjuna",
    body: "You've done the hard part. Hand us the dealer quote — we negotiate the number.",
    tier: "arjuna",
  },
  {
    q: "I want negotiation + protection through delivery",
    a: "Bhishma",
    body: "Negotiation plus a 60+ point remote PDI, document checks and on-call support till the car is yours.",
    tier: "bhishma",
  },
  {
    q: "I'm not sure which one I need",
    a: "₹21 Consultation",
    body: "A 15-minute call to figure out exactly where you are and what you actually need.",
    tier: null,
  },
];

export const WHAT_WE_NEGOTIATE = [
  { title: "Dealer Discount", body: "The strongest feasible discount on the on-road price." },
  { title: "Insurance", body: "Overpriced policies and unnecessary add-on covers, challenged." },
  { title: "Accessories", body: "Bundled packages renegotiated or removed where they don't earn their price." },
  { title: "Dealer Charges", body: "Every handling, logistics and 'processing' line reviewed one by one." },
  { title: "Exchange Value", body: "Your trade-in protected against a lowball valuation." },
  { title: "Finance Costs", body: "Loan structuring and finance-linked charges reviewed for hidden margin." },
  { title: "Final On-Road Price", body: "The number that actually matters, benchmarked and signed." },
];

export const MARQUEE = [
  "First In India",
  "Your Saarthi",
  "Never Theirs",
  "Zero Dealer Commission",
  "Buyer-Side Only",
  "Written Savings Benchmark",
  "The Ghost Clause",
];

export const IMAGES = {
  heroCar:
    "https://images.unsplash.com/photo-1767272374026-178111631eca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwc2VkYW4lMjBkYXJrJTIwbW9vZHklMjBsaWdodGluZyUyMGNhcnxlbnwwfHx8fDE3ODQ2MTIyMTZ8MA&ixlib=rb-4.1.0&q=85",
  cityCar:
    "https://images.unsplash.com/photo-1764774518725-3ea2fc2460af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwc2VkYW4lMjBkYXJrJTIwbW9vZHklMjBsaWdodGluZyUyMGNhcnxlbnwwfHx8fDE3ODQ2MTIyMTZ8MA&ixlib=rb-4.1.0&q=85",
  pdi:
    "https://images.unsplash.com/photo-1637640125496-31852f042a60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjYXIlMjBlbmdpbmUlMjBpbnNwZWN0aW9uJTIwbWVjaGFuaWMlMjB0b29sc3xlbnwwfHx8fDE3ODQ2MTIyMTZ8MA&ixlib=rb-4.1.0&q=85",
  case1: "https://images.pexels.com/photos/7144201/pexels-photo-7144201.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  case2: "https://images.pexels.com/photos/7144212/pexels-photo-7144212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  founder: "/images/founder.jpg",
};

export function formatINR(n) {
  return "₹" + Number(n).toLocaleString("en-IN");
}
